import React from 'react';
import './index.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
      </div>
      <div className="loading-text">加载中...</div>
    </div>
  );
};

export default Loading;
